import { render } from "./LegislationPage.vue?vue&type=template&id=06374ac0&scoped=true"
import script from "./LegislationPage.vue?vue&type=script&lang=js"
export * from "./LegislationPage.vue?vue&type=script&lang=js"

import "./LegislationPage.vue?vue&type=style&index=0&id=06374ac0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06374ac0"]])

export default __exports__